import styled from 'styled-components'

export const Flex = styled.div`
  flex: 0 0 auto;
  
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/style/styled-components/objects/Flex.jsx